import {
//  IconButton,
  ImageList,
  ImageListItemBar,
//  useTheme,
} from "@mui/material";
//import ZoomOutMapRoundedIcon from "@mui/icons-material/ZoomOutMapRounded";
//import { ImageModal } from "./ImageModal";
import { useEffect, useState } from "react";
import { base } from "../styles";
import { ImageCard } from "./ImageCard";
import { useI18n } from "../locales";
//import { baseURL } from "../../../services/utils/apiClient";

type Prop = {
  mobility_full_image_url: string | null;
  device_install_image_url: string | null;
  device_serial_image_url: string | null;
  power_cable_image_url: string | null;
  mobility_sign_image_url: string | null;
  user_image_url: string | null;
};

export type ImageType = {
  title: string;
  url: string | null;
};

/**
 * 설치 확인 페이지 - 상세 정보 - 설치 사진 영역
 */
export const InstallImages = ({
  mobility_full_image_url,
  device_install_image_url,
  device_serial_image_url,
  power_cable_image_url,
  mobility_sign_image_url,
  user_image_url,
}: Prop) => {
  const { t } = useI18n();
  //const theme = useTheme();
  //const [open, setOpen] = useState(false); // 이미지 모달 오픈
  const [images, setImages] = useState<ImageType[]>([]); // 설치 사진 리스트
  //const [selectedTitle, setSelectedTitle] = useState<string | null>(null); // 클릭된 사진 타이틀

  // 모달 열기
  /*const handleOpenModal = (title: string) => {
    setSelectedTitle(title);
    setOpen(true);
  };

  // 모달 닫기
  const handleCloseModal = () => {
    setSelectedTitle(null);
    setOpen(false);
  };*/

  const openImageInNewTab = (imageSrc: string) => {
    window.open(imageSrc, '_blank');
  };

  // 이미지 리스트 데이터 설정
  useEffect(() => {
    setImages([
      { title: t.deviceDetail.overallView, url: mobility_full_image_url },
      { title: t.deviceDetail.terminalInstallation, url: device_install_image_url },
      { title: t.deviceDetail.terminalSerialSticker, url: device_serial_image_url },
      { title: t.deviceDetail.powerWiringStatus, url: power_cable_image_url },
      { title: t.deviceDetail.machineryTypePlate, url: mobility_sign_image_url },
      { title: t.deviceDetail.userPhoto, url: user_image_url },
    ]);
  }, [
    mobility_full_image_url,
    device_install_image_url,
    device_serial_image_url,
    power_cable_image_url,
    mobility_sign_image_url,
    user_image_url,
    t.deviceDetail.overallView,
    t.deviceDetail.terminalInstallation,
    t.deviceDetail.terminalSerialSticker,
    t.deviceDetail.powerWiringStatus,
    t.deviceDetail.machineryTypePlate,
    t.deviceDetail.userPhoto,
  ]);

  // 이미지 생성 함수
  const makeImage = (title: string, url: string | null) => {
    return (
      <ImageCard
        key={title}
        src={url ? `${process.env.REACT_APP_BASE_URL}${url}` : null}
        title={title}
        //onClickImg={() => handleOpenModal(title)}
        onClickImg={() => openImageInNewTab(url ? `${process.env.REACT_APP_BASE_URL}${url}`:"")}
      >
        <ImageListItemBar
          title={title}
          /*actionIcon={
            <IconButton
              onClick={() => handleOpenModal(title)}
              sx={{ color: theme.palette.neutral.light }}
            >
              <ZoomOutMapRoundedIcon />
            </IconButton>
          }*/
          sx={{
            borderBottomRightRadius: base.border_radius,
            borderBottomLeftRadius: base.border_radius,
          }}
        />
      </ImageCard>
    );
  };

  return (
    <>
      <ImageList>{images.map((el) => makeImage(el.title, el.url))}</ImageList>
      {/*open && (
        <ImageModal
          open={open}
          onClose={handleCloseModal}
          images={images}
          selectedTitle={selectedTitle}
        />
      )*/}
    </>
  );
};
